/** Snapshot passed to the Llama assistant (kept in sync from the form). */
export type RequisitionAiContext = {
  title: string;
  department: string;
  clientName?: string;
  employment_type: string;
  location: string;
  business_justification: string;
  must_have_skills: string[];
  nice_to_have_skills: string[];
};

export function emptyRequisitionAiContext(): RequisitionAiContext {
  return {
    title: '',
    department: '',
    employment_type: '',
    location: '',
    business_justification: '',
    must_have_skills: [],
    nice_to_have_skills: [],
  };
}

/** Fields the AI assistant or templates can merge into RequisitionForm (partial updates). */
export type RequisitionFormAssistPatch = {
  title?: string;
  department?: string;
  employment_type?: string;
  location?: string;
  business_justification?: string;
  internal_notes?: string;
  /** Merged with existing (deduped, case-insensitive). */
  must_have_skills?: string[];
  nice_to_have_skills?: string[];
};

export type RequisitionTemplate = {
  id: string;
  name: string;
  category: string;
  description: string;
  /** Shown in Templates tab — aligned with common ATS sections: role summary, requirements, logistics. */
  patch: RequisitionFormAssistPatch;
};
